import { render, staticRenderFns } from "./wordM1.vue?vue&type=template&id=771a6f28&"
import script from "./wordM1.vue?vue&type=script&lang=js&"
export * from "./wordM1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports